webpackJsonp([5],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_PENDING_ASYNC_STORE_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PROPERTIES_OF_THE_PLATFORM; });
/* Vuex mutations types for module global */
var TOGGLE_PENDING_ASYNC_STORE_ACTIONS = 'TOGGLE_PENDING_ASYNC_STORE_ACTIONS';
var SET_PROPERTIES_OF_THE_PLATFORM = 'SET_PROPERTIES_OF_THE_PLATFORM';

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TOKEN_VALIDATION_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILL_AUTH_SERVICE_POINT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_AFTER_AUTHORIZATION_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_FORM_TYPE; });
var SET_TOKEN_VALIDATION_STATE = 'SET_TOKEN_VALIDATION_STATE';
var FILL_AUTH_SERVICE_POINT_DATA = 'FILL_AUTH_SERVICE_POINT_DATA';
var TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA = 'TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA';
var SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA = 'SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA';
var SET_AFTER_AUTHORIZATION_URL = 'SET_AFTER_AUTHORIZATION_URL';
var SET_FORM_TYPE = 'SET_FORM_TYPE';

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManageTokenService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(95);




var ManageTokenService = function () {
  function ManageTokenService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ManageTokenService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ManageTokenService, null, [{
    key: 'addTokenToStorage',
    value: function addTokenToStorage(token) {
      __WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_TOKEN_STORAGE */].setItem('token', token);
    }
  }, {
    key: 'removeTokenFromStorage',
    value: function removeTokenFromStorage() {
      __WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_TOKEN_STORAGE */].clear();
    }
  }, {
    key: 'getTokenFromStorage',
    value: function getTokenFromStorage() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_TOKEN_STORAGE */].getItem('token');
    }
  }]);

  return ManageTokenService;
}();



/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hDeepCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hToggleArrayItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

/* Helpers file */


/**
 * name: hDeepCopy
 *
 * creates deep copy of object (HACK)
 *
 * @param {Object} object
 * @return {Object}
 */
var hDeepCopy = function hDeepCopy(object) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(object));
};

/**
 * name: hToggleArrayItem
 *
 * Creates an array of unique values that is the symmetric difference of the given arrays.
 * The order of result values is determined by the order they occur in the arrays.
 *
 * @param {Array} array
 * @param {any} item
 * @returns {Array} newArray
 */
var hToggleArrayItem = function hToggleArrayItem(array, item) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["xor"])(array, [item]);
};

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_mq__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translate__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(264);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_mq__["a" /* default */], {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_6__translate__["a" /* i18n */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] }
});

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    var loadedLanguages = [this.i18n.locale];
    var i18n = this.i18n;

    Vue.prototype.$lang = {
      getCurrentLang: function getCurrentLang() {
        return i18n.locale;
      },
      setLang: function setLang(lang) {
        if (i18n.locale !== lang) {
          if (!loadedLanguages.includes(lang)) {
            return __webpack_require__(210)("./" + lang.toUpperCase()).then(function (msgs) {
              i18n.setLocaleMessage(lang, msgs.default);
              loadedLanguages.push(lang);
              setI18nLanguage(lang);
            });
          }
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setI18nLanguage(lang));
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(lang);
      }
    };

    function setI18nLanguage(lang) {
      i18n.locale = lang;
    }
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./EN": [
		54
	],
	"./EN.js": [
		54
	],
	"./PL": [
		55
	],
	"./PL.js": [
		55
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 210;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_173c1b4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var normalizeComponent = __webpack_require__(106)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-173c1b4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_173c1b4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export authInterceptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorHandlerInterceptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errorsMessages__ = __webpack_require__(235);






/**
 * Authorization interceptor
 *
 * @param {any} config
 * @returns
 */
var authInterceptor = function authInterceptor() {};

var errorHandlerInterceptor = function errorHandlerInterceptor(error) {
  var errorMessage = __WEBPACK_IMPORTED_MODULE_2__translate__["a" /* i18n */].tc('http_errors.' + (error.response ? error.response.status : 500));
  var errorDescription = error.response.data.data.value ? error.response.data.data.value[0] : '';

  __WEBPACK_IMPORTED_MODULE_3_element_ui__["Notification"].error(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    title: errorMessage,
    message: errorDescription.charAt(0).toUpperCase() + errorDescription.slice(1)
  }, error.response.status === 406 && Object(__WEBPACK_IMPORTED_MODULE_4__errorsMessages__["a" /* prepareErrorMessageForNotAcceptableStatus */])(error.response.data.data, error.response.config.url)));

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prepareErrorMessageForNotAcceptableStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var errorMessages = {
  user: {
    exist: {
      title: 'Użytkownik istnieje',
      message: 'Użytkownik o podanym adresie email już istnieje'
    }
  },
  verification_code: {
    incorrect: {
      title: 'Nieprawidłowy kod',
      message: 'Wpisany kod jest nieprawidłowy'
    }
  }
};

var specificErrorMessagesForDedicatedUrl = {};

var prepareErrorMessageForNotAcceptableStatus = function prepareErrorMessageForNotAcceptableStatus(errorData, errorUrl) {
  // get only first error
  var mismatchValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errorData)[0];
  var mismatchType = errorData[mismatchValue];

  return specificErrorMessagesForDedicatedUrl[errorUrl] || (errorMessages[mismatchValue] ? errorMessages[mismatchValue][mismatchType] : {
    title: 'Błąd',
    message: 'Wystąpił błąd podczas wykonywania operacji'
  });
};

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_BrandService__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(251);




var INITIAL_STATE = {
  pendingAsyncStoreActions: [],
  lang: 'pl',
  brand: {
    main_color: '#24262d',
    second_color: '#393c45',
    accent_color: '#42a5f5',
    logo: '',
    registration_additional_data: null,
    additional_styles: '',
    logo_above_form: '',
    forms: []
  },
  support_email: 'devs@telestrada.pl'
};

var getters = {
  pendingAsyncStoreActions: function pendingAsyncStoreActions(state) {
    return {
      includes: function includes() {
        var pendingActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var _pendingActions = pendingActions;
        return state.pendingAsyncStoreActions.some(function (a) {
          return _pendingActions.includes(a);
        });
      }
    };
  },
  brandTheme: function brandTheme(state) {
    return __WEBPACK_IMPORTED_MODULE_0__services_BrandService__["a" /* default */].generateBrandTheme(state.brand);
  },
  brandLogo: function brandLogo(state) {
    return state.brand.logo;
  },
  logoAboveForm: function logoAboveForm(state) {
    return state.brand.logo_above_form;
  },
  forms: function forms(state) {
    return state.brand.forms;
  },
  brandRegistrationAdditionalData: function brandRegistrationAdditionalData(state) {
    return state.brand.registration_additional_data;
  },
  lang: function lang(state) {
    return state.lang;
  },
  supportEmail: function supportEmail(state) {
    return state.support_email;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  getters: getters
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrandService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_color__);




// utils
function prepareCustomStyleForLayout(colors) {
  var mainColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colors.main_color);
  var secondColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colors.second_color);
  var accentColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colors.accent_color);

  return '\n    .LayoutWrapper__content {\n      background-color: ' + mainColor + ';\n    }\n    .LayoutWrapper__column--left {\n      background-color: ' + mainColor + ';\n      color: ' + (mainColor.luminosity() >= 0.50 ? mainColor.darken(0.8).hex() : mainColor.lighten(7).hex()) + '\n    }\n    .LayoutWrapper__column--right {\n      background-color: ' + secondColor + ';\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(7).hex()) + ';\n    }\n    .LayoutWrapper__contact-content {\n      border-top: 1px solid  ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.9).hex() : secondColor.lighten(1).hex()) + '\n    }\n    .LayoutWrapper__contact-column--left {\n      color: ' + accentColor + '\n    }\n    .LayoutWrapper__column--right .el-loading-mask {\n      background-color: ' + secondColor.alpha(0.7) + ';\n      width: 50%;\n      left: auto;\n      height: 100%;\n      position: fixed;\n    }\n    @media (max-width: 648px) {\n      .LayoutWrapper__column--right .el-loading-mask {\n        width: 100%;\n      }\n    }\n    .LayoutWrapper__column--right .el-loading-spinner .path {\n      stroke: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n    }\n    .LayoutWrapper__column--right .el-loading-spinner .el-loading-text {\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n    }\n  ';
}

function prepareCustomStyleForForm(colors) {
  var mainColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colors.main_color);
  var secondColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colors.second_color);
  var accentColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colors.accent_color);

  return '\n    .DynamicForm {\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + '\n    }\n    .el-form-item__error {\n      left: 0px;\n      right: 0px;\n      margin-top: 3px;\n      text-align: center;\n    }\n    .el-form-item__content {\n      margin-bottom: 20px;\n    }\n    .el-input-group__prepend {\n      font-size: 26px;\n      padding: 0 0 0 15px;\n      border-right: 0px !important;\n      border-radius: 50px 0px 0px 50px;\n      transition: border-color .2s cubic-bezier(.645,.045,.355,1);\n      color: ' + accentColor + ';\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()) + ';\n      border: 1px solid ' + accentColor + ';    \n    }\n    .el-form-item.is-error .el-input-group__prepend{\n      border-color: #f56c6c;\n      border-right: 0px !important;\n    }\n    .el-form-item.is-success .el-input-group__prepend {\n      border-color: ' + accentColor + ';\n      border-right: 0px !important;\n    }         \n    .el-input-group__append {\n      font-size: 26px;\n      border-left: 0px !important;\n      border-radius: 0px 50px 50px 0px;\n      transition: border-color .2s cubic-bezier(.645,.045,.355,1);\n      color: ' + accentColor + ';\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()) + ';\n      border: 1px solid ' + accentColor + ';          \n    }\n    .el-form-item.is-error .el-input-group__append {\n      border-color: #f56c6c;\n      border-left: 0px;      \n    }\n    .el-form-item.is-success .el-input-group__append {\n      border-color: ' + accentColor + ';\n      border-left: 0px !important;\n    }               \n    .el-input__inner {\n      border-left: 0px !important;\n      border-right: 0px !important;\n      border-radius: 0px 50px 50px 0px;\n      height: 45px;\n      line-height: 45px;\n      padding-left: 4px;\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ' !important;\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()) + ';\n      border: 1px solid ' + accentColor + ';      \n    }\n    .el-input__inner:hover {\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()) + ';\n      border: 1px solid ' + accentColor + ';       \n    }\n    .el-input__inner:focus {\n      border: 1px solid ' + accentColor + ';\n    }\n    .DynamicForm .el-form-item.is-success .el-input__inner, .DynamicForm .el-form-item.is-success .el-input__inner:focus {\n      border-color: ' + accentColor + ';\n    }          \n    .el-form-item.is-success .el-input__inner {\n      border-color: ' + accentColor + ';\n    }\n    .el-input.is-disabled {\n      opacity: 0.8;\n      filter: blur(2px);\n    }\n    .el-input.is-disabled .el-input__inner {\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.3).hex() : secondColor.lighten(0.3).hex()) + ';      \n    }\n    .ShFormGenerator__label {\n      font-size: 14px;\n      font-weight: 300;\n      line-height: 140%;\n      text-align: center;\n    }\n    .ShFormGenerator__element-login {\n      margin-bottom: 20px;\n    }\n    .ShFormGenerator__link-reminder {\n      color: ' + accentColor + ';\n      text-align: right;\n      text-decoration: none;\n    }\n    .ShFormGenerator__link-reminder a{\n      color: ' + accentColor + ';\n      text-decoration: none;\n    }\n    .DynamicForm .el-form-item {\n      position: relative;\n    }\n    .DynamicForm .el-form-item__label {\n      top: 10px;\n      z-index: 2;\n      left: 50px;\n      padding: 0;\n      color: #66738F;\n      font-size: 8px;\n      transition: .3s;\n      font-weight: 500;\n      line-height: 12px;\n      position: absolute;\n      visibility: hidden;\n      pointer-events:none;\n      transition:0.2s ease all; \n      -moz-transition:0.2s ease all; \n      -webkit-transition:0.2s ease all;\n    }\n    .DynamicForm .focused .el-form-item__label {\n      top: 2px;\n      visibility: visible;\n    }\n    .DynamicForm input:focus .el-form-item__label, .DynamicForm input:valid .el-form-item__label {\n      top:5px;\n      font-size:14px;\n      color:#5264AE;\n    }\n    .DynamicForm .el-form-item__label::before {\n      display: none;\n    }\n    .ShFormGenerator__element-password {\n      position: relative;\n    }\n    .el-checkbox {\n      width: 100%;\n      text-align: center;\n    }\n    .el-checkbox-group {\n      text-align: center;\n    }\n    .DynamicForm__resend-code{\n      text-align: center;\n      margin-top: 20px;\n      cursor: pointer;\n    }\n    .DynamicForm__resend-code--resned {\n      text-align: center;\n      margin-top: 20px;\n    }\n    .DynamicForm__resend-code:hover{\n      color: ' + accentColor + ';\n      text-decoration: underline;\n    }\n    .el-checkbox__input.is-checked + .el-checkbox__label {\n      color: ' + accentColor + ' !important;\n    }\n    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {\n      background-color: ' + accentColor + ' !important;\n      border-color: ' + accentColor + ' !important;\n    }\n    .el-checkbox__inner:hover, .el-checkbox__inner:focus {\n      border-color: ' + accentColor + ' !important;\n    }\n    .el-button--primary {\n      width: 100%;\n      height: 45px;\n      font-size: 16px;\n      line-height: 20px;\n      text-align: center;\n      border-radius: 50px;\n      text-transform: uppercase;\n      background: ' + accentColor + ';\n      color: ' + mainColor + ' !important;\n      border-color: ' + accentColor + ' !important;\n      transition: background-color .2s cubic-bezier(.645,.045,.355,1);\n    }\n    .el-button--primary:hover {\n      background-color: ' + accentColor.lighten(0.1).hex() + ' !important;\n    }\n    .el-button--primary:focus {\n      background: ' + accentColor.lighten(0.1).hex() + ' !important;\n    }\n    .el-button--warning {\n      border-color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';     \n    }\n    .el-button--warning:hover {\n      border-color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.fade(0.2).darken(0.8).hex() : secondColor.fade(0.2).lighten(0.2).hex()) + ';     \n    }\n    .el-button--warning:focus {\n      border-color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n      color: ' + (secondColor.luminosity() >= 0.50 ? secondColor.darken(0.8).hex() : secondColor.lighten(2).hex()) + ';\n      background: ' + (secondColor.luminosity() >= 0.50 ? secondColor.fade(0.2).darken(0.8).hex() : secondColor.fade(0.2).lighten(0.2).hex()) + ';         \n    }\n  ';
}

// export service

var BrandService = function () {
  function BrandService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BrandService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BrandService, null, [{
    key: 'generateBrandTheme',
    value: function generateBrandTheme(colors) {
      return {
        layout: prepareCustomStyleForLayout(colors),
        form: prepareCustomStyleForForm(colors),
        additionalStyles: colors.additional_styles
      };
    }
  }]);

  return BrandService;
}();



/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types__ = __webpack_require__(103);


/* harmony default export */ __webpack_exports__["a"] = ({
  setPropertiesOfThePlatform: function setPropertiesOfThePlatform(_ref, _ref2) {
    var commit = _ref.commit;
    var lang = _ref2.lang,
        support_email = _ref2.support_email,
        brand = _ref2.brand;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["a" /* SET_PROPERTIES_OF_THE_PLATFORM */], { lang: lang, support_email: support_email, brand: brand });
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types__ = __webpack_require__(103);


var _TOGGLE_PENDING_ASYNC;

/* Vuex mutations types for module App */




/* harmony default export */ __webpack_exports__["a"] = (_TOGGLE_PENDING_ASYNC = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_ASYNC, __WEBPACK_IMPORTED_MODULE_2__mutations_types__["b" /* TOGGLE_PENDING_ASYNC_STORE_ACTIONS */], function (state, payload) {
  var _state = state;
  _state.pendingAsyncStoreActions = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["b" /* hToggleArrayItem */])(_state.pendingAsyncStoreActions, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_ASYNC, __WEBPACK_IMPORTED_MODULE_2__mutations_types__["a" /* SET_PROPERTIES_OF_THE_PLATFORM */], function (state, payload) {
  var _state = state;
  _state.lang = payload.lang;
  _state.brand = payload.brand;
  _state.support_email = payload.support_email;
}), _TOGGLE_PENDING_ASYNC);

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(263);
// Vuex authServicesPoints module main file



var INITIAL_STATE = {
  tokenIsValid: false,
  isWaitingForAuthServicePointData: true,
  params: [],
  type: null,
  platform_url: null,
  gateway: null,
  afterAuthorizationUrl: null
};

var getters = {
  tokenIsValid: function tokenIsValid(state) {
    return state.tokenIsValid;
  },
  isWaitingForAuthServicePointData: function isWaitingForAuthServicePointData(state) {
    return state.isWaitingForAuthServicePointData;
  },
  form: function form(state) {
    return {
      params: state.params,
      type: state.type
    };
  },
  gateway: function gateway(state) {
    return state.gateway;
  },
  platformUrl: function platformUrl(state) {
    return state.platform_url;
  },
  afterAuthorizationUrl: function afterAuthorizationUrl(state) {
    return state.afterAuthorizationUrl;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_decorators__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations_types__ = __webpack_require__(105);




var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_decorators__["a" /* togglePendingStoreActions */])(), (_obj = {
  getAuthServicePointSettingsByToken: function getAuthServicePointSettingsByToken(_ref) {
    var _this = this;

    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _data$data, params, type, platform_url, gateway, lang, brand, support_email;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].get('/authServicesPoints/getAuthServicePointSettingsByToken?token=' + token);

            case 3:
              _data$data = _context.sent.data.data;
              params = _data$data.params;
              type = _data$data.type;
              platform_url = _data$data.platform_url;
              gateway = _data$data.gateway;
              lang = _data$data.lang;
              brand = _data$data.brand;
              support_email = _data$data.support_email;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["a" /* FILL_AUTH_SERVICE_POINT_DATA */], { params: params, type: type, platform_url: platform_url, gateway: gateway });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["e" /* SET_TOKEN_VALIDATION_STATE */], { isValid: true });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["f" /* TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA */]);

              dispatch('global/setPropertiesOfThePlatform', { lang: lang, brand: brand, support_email: support_email }, { root: true });
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](0);

              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["e" /* SET_TOKEN_VALIDATION_STATE */], { isValid: false });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["f" /* TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA */]);

            case 21:
              return _context.abrupt('return', token);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 17]]);
    }))();
  },
  changeFormState: function changeFormState(_ref2, state) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["c" /* SET_FORM_TYPE */], state);
              } catch (err) {
                console.log(err);
              }

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  loginToASP: function loginToASP(_ref3, _ref4) {
    var _this3 = this;

    var commit = _ref3.commit;
    var params = _ref4.params,
        token = _ref4.token,
        gateway = _ref4.gateway;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post('/authServicesPoints/loginToASP', { params: params, token: token, gateway: gateway });

            case 3:
              url = _context3.sent.data.data.url;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["b" /* SET_AFTER_AUTHORIZATION_URL */], { url: url });
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.log(_context3.t0);

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  registerToASP: function registerToASP(_ref5, _ref6) {
    var _this4 = this;

    var commit = _ref5.commit;
    var params = _ref6.params,
        token = _ref6.token,
        gateway = _ref6.gateway;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post('/authServicesPoints/registerToASP', { params: params, token: token, gateway: gateway });

            case 3:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["c" /* SET_FORM_TYPE */], 'confirm');
              _context4.next = 9;
              break;

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4['catch'](0);

              console.log(_context4.t0);

            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 6]]);
    }))();
  },
  changePasswordToASP: function changePasswordToASP(_ref7, _ref8) {
    var _this5 = this;

    var commit = _ref7.commit;
    var params = _ref8.params,
        token = _ref8.token,
        gateway = _ref8.gateway;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              params.platform = window.location.origin;
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post('/authServicesPoints/changePasswordToASP', { params: params, token: token, gateway: gateway });

            case 4:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["c" /* SET_FORM_TYPE */], 'email_change_password');
              _context5.next = 10;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.log(_context5.t0);

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  confirmChangePasswordToASP: function confirmChangePasswordToASP(_ref9, _ref10) {
    var _this6 = this;

    var commit = _ref9.commit;
    var params = _ref10.params,
        token = _ref10.token,
        gateway = _ref10.gateway;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post('/authServicesPoints/confirmChangePasswordToASP', { params: params, token: token, gateway: gateway });

            case 3:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["c" /* SET_FORM_TYPE */], 'confirm_new_change_password');
              _context6.next = 9;
              break;

            case 6:
              _context6.prev = 6;
              _context6.t0 = _context6['catch'](0);

              console.log(_context6.t0);

            case 9:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 6]]);
    }))();
  },
  sendVerificationCode: function sendVerificationCode(_ref11, _ref12) {
    var _this7 = this;

    var commit = _ref11.commit;
    var params = _ref12.params,
        token = _ref12.token,
        gateway = _ref12.gateway;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post('/authServicesPoints/sendVerificationCode', { params: params, token: token, gateway: gateway });

            case 3:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["c" /* SET_FORM_TYPE */], 'verification');
              _context7.next = 9;
              break;

            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7['catch'](0);

              console.log(_context7.t0);

            case 9:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 6]]);
    }))();
  },
  resendVerificationCode: function resendVerificationCode(_, _ref13) {
    var _this8 = this;

    var params = _ref13.params,
        token = _ref13.token,
        gateway = _ref13.gateway;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post('/authServicesPoints/sendVerificationCode', { params: params, token: token, gateway: gateway });

            case 3:
              _context8.next = 8;
              break;

            case 5:
              _context8.prev = 5;
              _context8.t0 = _context8['catch'](0);

              console.log(_context8.t0);

            case 8:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 5]]);
    }))();
  },
  setStateForWaitingForAuthServicePointData: function setStateForWaitingForAuthServicePointData(_ref14, newState) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutations_types__["d" /* SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA */], newState);
  }
}, (_applyDecoratedDescriptor(_obj, 'changeFormState', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'changeFormState'), _obj), _applyDecoratedDescriptor(_obj, 'loginToASP', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'loginToASP'), _obj), _applyDecoratedDescriptor(_obj, 'registerToASP', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'registerToASP'), _obj), _applyDecoratedDescriptor(_obj, 'changePasswordToASP', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'changePasswordToASP'), _obj), _applyDecoratedDescriptor(_obj, 'confirmChangePasswordToASP', [_dec5], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'confirmChangePasswordToASP'), _obj), _applyDecoratedDescriptor(_obj, 'sendVerificationCode', [_dec6], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'sendVerificationCode'), _obj), _applyDecoratedDescriptor(_obj, 'resendVerificationCode', [_dec7], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'resendVerificationCode'), _obj)), _obj));

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return togglePendingStoreActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(57);




/**
 * Decorator for Vuex action's.
 */
var togglePendingStoreActions = function togglePendingStoreActions() {
  return function (target, key, descriptor) {
    var _descriptor = descriptor;
    var orginalMethod = _descriptor.value;
    _descriptor.value = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var storeActionsName;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                storeActionsName = key;

                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('global/TOGGLE_PENDING_ASYNC_STORE_ACTIONS', storeActionsName);
                _context.next = 4;
                return orginalMethod.apply(this, args);

              case 4:
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('global/TOGGLE_PENDING_ASYNC_STORE_ACTIONS', storeActionsName);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();
    return descriptor;
  };
};

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(105);


var _FILL_AUTH_SERVICE_PO;



/* harmony default export */ __webpack_exports__["a"] = (_FILL_AUTH_SERVICE_PO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_AUTH_SERVICE_PO, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* FILL_AUTH_SERVICE_POINT_DATA */], function (state, payload) {
  var _state = state;
  _state.params = payload.params;
  _state.platform_url = payload.platform_url;
  _state.type = payload.type;
  _state.gateway = payload.gateway;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_AUTH_SERVICE_PO, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["e" /* SET_TOKEN_VALIDATION_STATE */], function (state, payload) {
  var _state = state;
  _state.tokenIsValid = payload.isValid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_AUTH_SERVICE_PO, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["f" /* TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA */], function (state) {
  var _state = state;
  _state.isWaitingForAuthServicePointData = !_state.isWaitingForAuthServicePointData;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_AUTH_SERVICE_PO, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["d" /* SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA */], function (state, payload) {
  var _state = state;
  _state.isWaitingForAuthServicePointData = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_AUTH_SERVICE_PO, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["b" /* SET_AFTER_AUTHORIZATION_URL */], function (state, payload) {
  var _state = state;
  _state.afterAuthorizationUrl = payload.url;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_AUTH_SERVICE_PO, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["c" /* SET_FORM_TYPE */], function (state, payload) {
  var _state = state;
  _state.type = payload;
}), _FILL_AUTH_SERVICE_PO);

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(266);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */],
  mode: 'history'
}));

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** All routes configurations */
/* harmony default export */ __webpack_exports__["a"] = ([{ path: '/',
  name: 'DecodeToken',
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 269));
  },
  props: function props(route) {
    return { token: route.query.token };
  },
  children: [{
    path: '/auth',
    name: 'login',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 270));
    }
  }, {
    path: '/error',
    name: 'error',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 271));
    }
  }, {
    path: '/info',
    name: 'info',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 272));
    }
  }]
}]);

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  http_errors: {
    400: 'Something went wrong... please try again in a moment!',
    401: 'No permissions!',
    403: 'Something went wrong... please try again in a moment!',
    404: 'Something went wrong... please try again in a moment!',
    406: 'Incorrect payment details or validity has expired.',
    429: 'Too many requests. Please try again in a moment',
    500: 'A temporary problem with a redirect to a payment. Choose a different payment method or try again in a moment.',
    503: 'Server error. Please try again.',
    504: 'Waiting time exceeded, please try again.'
  },
  header: {
    language: 'Language'
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  http_errors: {
    400: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    401: 'Brak uprawnień!',
    403: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    404: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    406: 'Nieprawidłowe dane',
    429: 'Za dużo prób. Prosimy spróbować ponownie za chwilę',
    500: 'Chwilowy problem z przekieowaniem. Spróbuj za chwilę jeszcze raz.',
    503: 'Błąd serwera. Prosimy spróbować ponownie',
    504: 'Przekroczono czas oczekiwania, proszę spróbować jeszcze raz'
  },
  header: {
    language: 'Język'
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_global__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_authServicesPoints__ = __webpack_require__(255);
/* Vuex store */



// MODULES /////////////////////////////////////////////////////////////////////



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    global: __WEBPACK_IMPORTED_MODULE_2__modules_global__["a" /* default */],
    authServicesPoints: __WEBPACK_IMPORTED_MODULE_3__modules_authServicesPoints__["a" /* default */]
  },
  strict: !Object({"NODE_ENV":"production","API_URL":"/api","SENTRY":true,"APP_VERSION":"staging - Thu Feb 12 22:14:16 UTC 2026"}).DEBUG_MODE
}));

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_ShI18n__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_PL__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_EN__ = __webpack_require__(54);
/* unused harmony reexport ShI18n */




// app language



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'pl',
  fallbackLocale: 'pl',
  messages: {
    pl: __WEBPACK_IMPORTED_MODULE_3__lang_PL__["default"],
    en: __WEBPACK_IMPORTED_MODULE_4__lang_EN__["default"]
  }
});

__WEBPACK_IMPORTED_MODULE_2__plugins_ShI18n__["a" /* default */].i18n = i18n;



/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__ = __webpack_require__(107);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    afterAuthorizationUrl: function afterAuthorizationUrl() {
      return this.$store.getters['authServicesPoints/afterAuthorizationUrl'];
    }
  },
  watch: {
    afterAuthorizationUrl: function afterAuthorizationUrl(url) {
      __WEBPACK_IMPORTED_MODULE_0__services_ManageTokenService__["a" /* default */].removeTokenFromStorage();
      window.location.href = url;
    }
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_TOKEN_STORAGE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors__ = __webpack_require__(234);



var API_HEADERS = {};
var API_CONFIG = {};
var API_TOKEN_STORAGE = sessionStorage;

// SET CONFIGURATION
API_HEADERS['X-Requested-With'] = 'XMLHttpRequest';
API_CONFIG.baseURL = "/api";
API_CONFIG.headers = API_HEADERS;
API_CONFIG.timeout = 10000;
API_CONFIG.withCredentials = !"production" === 'development';

var API = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(API_CONFIG);

API.interceptors.request.use(function (config) {
  return config;
}, __WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* errorHandlerInterceptor */]);
API.interceptors.response.use(function (config) {
  return config;
}, __WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* errorHandlerInterceptor */]);

// EXPORT CONFIGURATION


/***/ })

},[111]);


// WEBPACK FOOTER //
// static/js/app.80f6fd02c1b28ae6d4c0.js